export const ACCESS_TOKEN = '_ac_tk';
export const LAST_UPDATED_AT = '_last_updated_at';
